<!-- 获取指定时间段支付账单信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC",
                "startTime":"20160723162730",
                "endTime":"20160724162730",
                "pageNum":"1",
                "pageSize":"10"
            },
            responseCode: { "data": { "billList": [{ "carNo": "粤B12346", "cardNumber": "FFFFFFD9", "disValue": 0.00, "enterTime": "20170914151412", "leaveTime": "20170914151737", "parkingCode": "2017091415141204940854", "payDate": "20170914151749", "payOrigin": 1, "payValue": 0.00, "paymentMode": 9 }], "currCount": 1, "total": 13 }, "message": "业务成功", "resultCode": 0, "status": 1 },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取某停车场指定时间段缴费账单信息",
                t_url: this.commonUrls.test+"getParkPayBill",
                p_url: this.commonUrls.prod+"getParkPayBill",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '时间段起始时间，yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '时间段结束时间，yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'billList', info2: '是', info3: 'JSONArray', info4: '支付账单信息列表' }
                        ]
                },{
                    titleName: 'billList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'cardNumber', info2: '是', info3: 'String', info4: '卡票号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        { info1: 'leaveTime', info2: '否', info3: 'String', info4: '出场时间，yyyyMMddHHmmss，如果车辆未离场，此字段为空' },
                        { info1: 'payValue', info2: '是', info3: 'Decimal', info4: '支付金额' },
                        { info1: 'disValue', info2: '否', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '第三方系统缴费订单号' },
                        { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源，<url>参考附录:/Api/appendixData#appendixData_1</url>' },
                        { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                        { info1: 'paymentMode', info2: '是', info3: 'String', info4: '支付方式，<url>参考附录:/Api/appendixData#appendixData_0</url>' },
                        { info1: 'paymentModeRemark', info2: '是', info3: 'String', info4: '支付方式备注' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/parking/getParkPayBill.vue